import { gql } from "@apollo/client";

export const GET_CONDICIONES_GENERALES_CONTRATO = gql`
query CondicionGeneralRIByID (
    $idDatosGenerales: Int!
) {
    condicionGeneralRIByID (
        idDatosGenerales: $idDatosGenerales
    ){
        dispositivoParaVideoConf
        idComboRIValorFasePaciente
    }
}`;

export const adaptCondicionesGeneralesContrato = ({ condicionGeneralRIByID }) => {
  return {
    dispositivoParaVideoConf: condicionGeneralRIByID?.dispositivoParaVideoConf,
    idComboRIValorFasePaciente: condicionGeneralRIByID?.idComboRIValorFasePaciente
  };
};